import restaurantInstance from '../instance'

const fetchDishCourses = () => {
	return restaurantInstance.get('/dishCourses')
}

export default fetchDishCourses
